import Toast from './Toast';

interface ToasterType {
    id: string;
    message: string;
    type: 'success' | 'error' | 'info' | 'warning';
}

interface ToastContainerProps {
    removeToaster: (id: string) => void,
    toastData: ToasterType[],
}

export const ToastContainer = ({ toastData, removeToaster }: ToastContainerProps) => {
    return (
        <div className="fixed top-4 right-0 space-y-2 z-[9999999]">
            {toastData?.map((toast: ToasterType) => (
                <Toast
                    key={toast.id}
                    message={toast.message}
                    type={toast.type}
                    onClose={() => removeToaster(toast.id)}
                />
            ))}
        </div>
    );
};